(function ($) {
    $(function () {

        if ($('.page-template-template-programs').length) {
            return;
        }

        //Match Heights
        $.addMatchHeight($('.js-service-title:visible'));
        //$.addMatchHeight($('.js-program-card:visible'));
        $.addMatchHeight($('.js-text-block:visible'));
        //$.addMatchHeight($('.program_taxonomies:visible'));
        //$.addMatchHeight($('.js-search-title:visible'));
        $.addMatchHeight($('.js-service-excerpt:visible'));
        $.addMatchHeight($('.js-text-block:visible'));
        $.addMatchHeight($('.js-program-excerpt:visible'));
        $.addMatchHeight($('.js-program-text-wrapper:visible'));
        /* $.addMatchHeight($('.js-program-card-text-block')); */
    });
})(jQuery);